import { Stack, TextField } from '@mui/material'
import { Controller } from 'react-hook-form';
import IInputData from '../../interfaces/input.interface';
import './input.scss';

export const Input = ({inputData, control, register}:{inputData: IInputData, control?: any, register: any}) => {

    return (
        <div className="contain-input">
            <Controller
            name={inputData.name}
            control={control}
            render={({
                field: { onChange, value },
                fieldState: { error },
                formState,
            }) => (
                <Stack spacing={2}>
                    <TextField{...register(inputData.name, { required: inputData.required })}
                        helperText={inputData.helperText?inputData.helperText:error ? error.message : null}
                        size={inputData.size}
                        type={inputData.type}
                        variant={inputData.variant}
                        label={inputData.label}
                        required={inputData.required}
                        error={!!error}
                        onChange={onChange}
                        value={value}
                        fullWidth
                        className='input-style'
                    />
                </Stack>
            )}
        />
        </div>
    );
}